import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 2770517A-B0A3-4AC5-A6E6-6EFD9DA2C3E5
 * name flash-alert-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-alert-outline.svg
 * tags
 * - Weather 
 * - Alert / Error 
 */
export const FlashAlertOutlineIcon = createSvgIcon(<><path d="M5,2H15L11.5,9H15L8,22V14H5V2M7,4V12H10V14.66L12,11H8.24L11.76,4M17,15H19V17H17V15M17,7H19V13H17V7Z" /></>, 'FlashAlertOutlineIcon');
export default FlashAlertOutlineIcon